import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { convertDate } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { formatDayMonth } from "utils/formatDate";
import {
  getListChiDelete,
  updateDataSearch,
} from "../../../../actions/DanhSachChiDelete";
import DateTimePicker from "components/GenericComponent/DateTimePicker";

export const SearchBarDesktop = ({}) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchChiDelete); //dataSearchTaiSan dinh nghia o rootreducer

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
        page: 1,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
  };

  const onSearch = () => {
    dispatch(getListChiDelete(dataSearch));
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          page: 1,
        })
      );
      dispatch(getListChiDelete(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  // convert sự kiện tìm kiếm từ ngày đến ngày
  var dateFrom = currentDate();
  if (dataSearch.dateFrom === "01/01/2001") dateFrom = "";
  else dateFrom = dataSearch.dateFrom;
  var dateTo = currentDate();
  if (dataSearch.dateTo === "01/01/4000") dateTo = "";
  else dateTo = dataSearch.dateTo;
  dateTo = convertDate(dateTo);
  dateFrom = convertDate(dateFrom);
  return (
    <>
      <div className="search-new hidden-mobile-main show-table-main">
        <div className="input-sm-new input-new-25">
          <label className="font-color-default font-bold">Tên người nhận</label>
          <input
            type="name"
            className="form-control input-sm"
            placeholder="Tên người nhận"
            value={dataSearch.name}
            onChange={updateTextValue("name")}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Từ ngày</label>
          <DateTimePicker
            value={dateFrom}
            onChange={onChangeDate("dateFrom")}
            placeholder="Từ ngày"
            name="dateFrom"
          ></DateTimePicker>
        </div>

        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Đến ngày</label>
          <DateTimePicker
            value={dateTo}
            onChange={onChangeDate("dateTo")}
            placeholder="Đến ngày"
            name="dateFrom"
          ></DateTimePicker>
        </div>
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Người xóa</label>
          <input
            className="form-control input-sm"
            value={dataSearch.NguoiXoa || ""}
            onChange={updateTextValue("NguoiXoa")}
            onKeyDown={handleKeyDown}
            placeholder="Người xóa"
          />
        </div>
        <div className="input-sm-new input-new-18 search-main-new">
          <button
            type="submit"
            className="btn btn-info-new"
            style={{ marginTop: "28px", paddingTop: "7px" }}
            onClick={onSearch}
          >
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
        </div>
      </div>
    </>
  );
};
